import React, { useCallback, useState } from 'react';
import { createContextHardened } from '../Helper/ContextHelper';

interface Context {
  isPanelOpen: boolean;
  setPanelOpen: (isOpen: boolean) => void;
  /** Returns true when panel has opened */
  togglePanel: () => boolean;
}
const [ControlContext, useContentControl] = createContextHardened<Context>('ContentControl');
export { useContentControl };

const ContentControlProvider = ({ children }: { children: React.ReactNode }): React.JSX.Element => {
  const [isPanelOpen, setPanelOpen] = useState<boolean>(false);

  const togglePanel = useCallback(() => {
    const newState = !isPanelOpen;
    setPanelOpen(newState);
    return newState;
  }, [isPanelOpen]);

  return (
    <ControlContext.Provider
      value={{
        isPanelOpen,
        setPanelOpen,
        togglePanel,
      }}
    >
      {children}
    </ControlContext.Provider>
  );
};

export default ContentControlProvider;
